import { FlaskConical, FileCheck2, Snowflake, Truck } from "lucide-react";

// Condensed trust, a single row of 4 icons. Replaces the previous three
// full-screen sections (LotPipeline, Guarantees, Manufacturer) which each
// hammered a similar point. The deep versions of these claims live on
// /verify (COA + Janoshik walkthrough) and /about (Trenta distributor
// narrative) so nothing has been deleted, it's just moved off the top of
// the homepage.
const ITEMS = [
  { icon: FlaskConical, title: "HPLC ≥ 99.5%", sub: "Every lot" },
  { icon: FileCheck2, title: "Public COA", sub: "Before purchase" },
  { icon: Snowflake, title: "Cold-chain", sub: "2-8°C tracked" },
  { icon: Truck, title: "UK / EU dispatch", sub: "1-2 business days" },
];

export default function TrustStrip() {
  return (
    <section className="border-b border-line bg-white" data-testid="trust-strip">
      <div className="container-pd py-8">
        <ul className="grid grid-cols-2 gap-6 sm:grid-cols-4">
          {ITEMS.map(({ icon: Icon, title, sub }) => (
            <li key={title} className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brandbluelight text-brandblue">
                <Icon className="h-5 w-5" strokeWidth={1.75} />
              </span>
              <div className="min-w-0">
                <p className="font-heading text-sm font-bold text-ink">{title}</p>
                <p className="text-xs text-subtle">{sub}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
